<h3 sidenav-title>{{ isSubmissionStatus ? 'Change Submission Status' : 'Change Violation Status' }}</h3>

<sidenav-content>
    <form [formGroup]="formGroup">
        <div class="form-group">
            <label>{{ 'Current Status of ' + (isSubmissionStatus ? 'Submission' : 'Violation') }}</label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <input type="text"
                       matInput
                       formControlName="currentStatus"
                       [attr.aria-label]="isSubmissionStatus ? 'Form submission status' : 'Violation status'">
            </mat-form-field>
        </div>

        <div class="form-group">
            <label>{{ 'Change Status To' }}</label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-select [panelClass]="'v2-panel'" placeholder="{{ 'Select Status' }}" formControlName="status">
                    <mat-option *ngFor="let status of data.statuses"
                                [disabled]="status.id === selectedStatusId"
                                [value]="status.id">
                        {{ status.title }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form-group">
            <mat-slide-toggle formControlName="sendEmail" color="primary" disableRipple>
                <span [innerHTML]="'Send status change email' + (hasSelectedRecipients ? ' to' : '')"></span>
                <button *ngIf="hasSelectedRecipients" linkButton preventClick
                        [innerHTML]="formGroup.get('recipients').value.length | i18nPlural: recipientsMapping"
                        (click)="showNotificationMemberSelector()">
                </button>
            </mat-slide-toggle>
        </div>

        <ng-container *ngIf="isViolationStatus" formGroupName="templates">
            <div class="form-group">
                <mat-slide-toggle formControlName="changeTemplate" color="primary" disableRipple>
                    {{ 'Change violation template used in notification' }}
                </mat-slide-toggle>
            </div>

            <section *ngIf="formGroup.get('templates.changeTemplate').value">
                <div class="form-group">
                    <label>{{ 'Header Template' }}</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-select [panelClass]="'v2-panel'" formControlName="headerTemplate">
                            <mat-option [value]="0">{{ 'No Change' }}</mat-option>
                            <mat-option *ngFor="let template of violationTemplates?.header"
                                        [value]="template.id">
                                {{ template.header }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-group">
                    <label>{{ 'Body Template' }}</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-select [panelClass]="'v2-panel'" formControlName="bodyTemplate">
                            <mat-option [value]="0">{{ 'No Change' }}</mat-option>
                            <mat-option *ngFor="let template of violationTemplates?.body"
                                        [value]="template.id">
                                {{ template.title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-group">
                    <label>{{ 'Footer Template' }}</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-select [panelClass]="'v2-panel'" formControlName="footerTemplate">
                            <mat-option [value]="0">{{ 'No Change' }}</mat-option>
                            <mat-option *ngFor="let template of violationTemplates?.footer"
                                        [value]="template.id">
                                {{ template.title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </section>
        </ng-container>
    </form>
</sidenav-content>

<sidenav-actions>
    <button mat-flat-button disableRipple color="primary" [disabled]="isSaving" (click)="applyStatus()">{{ 'Apply Status' }}</button>
    <button-spacer></button-spacer>
    <button mat-flat-button disableRipple color="accent" sidenav-close [disabled]="isSaving">{{ 'Cancel' }}</button>
</sidenav-actions>
